/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Use_Clock_TimeInputs */

const en_subtitle_export_use_clock_time = /** @type {(inputs: Subtitle_Export_Use_Clock_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Clock Time`)
};

const fr_subtitle_export_use_clock_time = /** @type {(inputs: Subtitle_Export_Use_Clock_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez l'heure.`)
};

const de_subtitle_export_use_clock_time = /** @type {(inputs: Subtitle_Export_Use_Clock_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uhrzeit verwenden`)
};

const it_subtitle_export_use_clock_time = /** @type {(inputs: Subtitle_Export_Use_Clock_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa l'ora dell'orologio`)
};

const ru_subtitle_export_use_clock_time = /** @type {(inputs: Subtitle_Export_Use_Clock_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Используйте часовое время`)
};

const es_subtitle_export_use_clock_time = /** @type {(inputs: Subtitle_Export_Use_Clock_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar el tiempo del reloj`)
};

const zh_cn2_subtitle_export_use_clock_time = /** @type {(inputs: Subtitle_Export_Use_Clock_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用时钟时间`)
};

const ja_subtitle_export_use_clock_time = /** @type {(inputs: Subtitle_Export_Use_Clock_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時計の時間を使用する`)
};

const hi_subtitle_export_use_clock_time = /** @type {(inputs: Subtitle_Export_Use_Clock_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घड़ी के समय का उपयोग करें`)
};

const pt_pt2_subtitle_export_use_clock_time = /** @type {(inputs: Subtitle_Export_Use_Clock_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar o horário do relógio`)
};

/**
* | output |
* | --- |
* | "Use Clock Time" |
*
* @param {Subtitle_Export_Use_Clock_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_use_clock_time = /** @type {((inputs?: Subtitle_Export_Use_Clock_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Use_Clock_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_use_clock_time(inputs)
	if (locale === "de") return de_subtitle_export_use_clock_time(inputs)
	if (locale === "it") return it_subtitle_export_use_clock_time(inputs)
	if (locale === "ru") return ru_subtitle_export_use_clock_time(inputs)
	if (locale === "es") return es_subtitle_export_use_clock_time(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_use_clock_time(inputs)
	if (locale === "ja") return ja_subtitle_export_use_clock_time(inputs)
	if (locale === "hi") return hi_subtitle_export_use_clock_time(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_use_clock_time(inputs)
	return en_subtitle_export_use_clock_time(inputs)
});